var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// components/label/common/src/label-props.ts
var labelSizes = ["sm", "md", "lg"];
var labelEmphasises = ["bold", "subtle"];
var defaultLabelProps = {
  emphasis: "subtle",
  inline: false,
  size: "md",
  disabled: false
};

// components/label/common/src/label-style-sheet.ts
import { typographyFontFamilyVariants } from "@gs-ux-uitoolkit-common/design-system";
import {
  StyleSheet
} from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
var labelStyleSheet = new StyleSheet("label", (props) => {
  var _a;
  return createComponentClassDefinitions(
    props,
    createDefaultStyledClasses,
    (_a = props.theme.styleOverrides) == null ? void 0 : _a.label
  );
});
function getLabelSizeMap(theme) {
  return {
    sm: __spreadProps(__spreadValues({}, theme.typography.body03), {
      paddingBottom: 0,
      paddingTop: 0
    }),
    md: __spreadValues({}, theme.typography.body02),
    lg: __spreadValues({}, theme.typography.body01)
  };
}
function createDefaultStyledClasses({
  theme,
  emphasis,
  size,
  inline,
  disabled
}) {
  return {
    root: {},
    label: __spreadProps(__spreadValues(__spreadValues({
      display: inline ? "inline" : "block",
      position: "relative",
      color: theme.text.secondary,
      marginBottom: "4px"
    }, getLabelSizeMap(theme)[size]), applyFontWeight(emphasis)), {
      opacity: disabled ? theme.state.disabledOpacity : 1
    })
  };
}
function applyFontWeight(emphasis) {
  return emphasis === "bold" ? typographyFontFamilyVariants["goldmanSans"].bold : typographyFontFamilyVariants["goldmanSans"].regular;
}

// components/label/common/src/label-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalClassName = "gs-label";
var getLabelRootClassNames = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(cssClasses.root, className, overrideClasses && overrideClasses.root, globalClassName);
};
var getLabelClassNames = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.label,
    overrideClasses && overrideClasses.label,
    `${globalClassName}__label`
  );
};
export {
  defaultLabelProps,
  getLabelClassNames,
  getLabelRootClassNames,
  labelEmphasises,
  labelSizes,
  labelStyleSheet
};
//# sourceMappingURL=index.mjs.map
